/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharechannelwhatsapp2Inputs */

const en_sharechannelwhatsapp2 = /** @type {(inputs: Sharechannelwhatsapp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const de_sharechannelwhatsapp2 = /** @type {(inputs: Sharechannelwhatsapp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

/**
* | output |
* | --- |
* | "WhatsApp" |
*
* @param {Sharechannelwhatsapp2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharechannelwhatsapp2 = /** @type {((inputs?: Sharechannelwhatsapp2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharechannelwhatsapp2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharechannelwhatsapp2(inputs)
	return de_sharechannelwhatsapp2(inputs)
});
export { sharechannelwhatsapp2 as "shareChannelWhatsapp" }